import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { useSelector } from "react-redux";
import identitySelectors from "../../../selectors/identity";
import { Message } from "semantic-ui-react";
import _ from "lodash";

export function LoginFailureMessage() {
  const query = queryString.parse(window.location.search);
  const postLogin = useSelector(identitySelectors.postLogin);
  const [queryError, setQueryError] = useState("");
  const [queryErrorHeader, setQueryErrorHeader] = useState("Sign In Failed");
  useEffect(() => {
    setQueryError(query.authErr as string);
    if (query.authErrHeader) {
      setQueryErrorHeader(query.authErrHeader as string);
    }
  }, []);
  if (queryError) {
    const rest = _.omit(query, ["authErr", "authErrHeader"]);
    const search = queryString.stringify(rest);
    window.history.replaceState({}, document.title, `${window.location.pathname}${search ? `?${search}` : ""}`);
  }
  return (
    <Message role='alert' aria-live='polite' className='feedback tw-p-4 tw-pl-5' negative>
      <Message.Header className='tw-text-base tw-font-semibold tw-text-red'>{queryErrorHeader}</Message.Header>
      <Message.Content className='tw-text-sm'>
        {queryError || _.get(postLogin, "error.response.message", "We were unable to log you in")}
      </Message.Content>
    </Message>
  );
}
